import React, { useEffect, useState } from "react";
import { Dayjs } from "dayjs";
import { SelectInputComponent } from "../../../../common/components";
import { CREATED_TIME_OPTIONS } from "../lead-filter.constant";
import CustomDateRangePicker from "../../../leads/lead-filter/lead-filter-options/custom-date-picket";
import { calculateDateRange } from "../../../../utils/filtersUtil";
import "./filter-options-select.scss"

interface CreatedTimeFilterProps {
  value: string[];
  onChange: (value: string[]) => void;
  isCreatedTimeEnabled?: boolean;
  onDateRangeChange: (fromDate: Date | null, toDate: Date | null) => void;
  createdTimeError?: string;
  createdTimeStartError?: string;
  createdTimeEndError?: string;
  setCreatedTimeFromDate: (date: Dayjs | null) => void;
  setCretedTimeToDate: (date: Dayjs | null) => void;
}

const CreatedTimeFilter: React.FC<CreatedTimeFilterProps> = ({
  value,
  onChange,
  isCreatedTimeEnabled,
  onDateRangeChange,
  createdTimeError,
  createdTimeStartError,
  createdTimeEndError,
  setCreatedTimeFromDate,
  setCretedTimeToDate
}) => {
  const [showCustomDate, setShowCustomDate] = useState(false);
  const [selectOpen, setSelectOpen] = useState(false);

  const handleOpen = () => {
    setSelectOpen(true)
  }
  const handleBlur = () => {
    setSelectOpen(false)
  }
  useEffect(() => {
    const selected = typeof value === "object" ? "" : value;
    setShowCustomDate(value.includes("Custom"));

    if (selected && selected !== "Custom") {
      const { from, to } = calculateDateRange(selected);
      onDateRangeChange(from ? from.toDate() : null, to ? to.toDate() : null);
    }
  }, [value]);

  const handleCustomRangeChange = (from: Dayjs | null, to: Dayjs | null) => {
    onDateRangeChange(from?.toDate() || null, to?.toDate() || null);
  };
  if (!isCreatedTimeEnabled) return null;


  return (
    <div className="filter-select-input-wrapper" >
      <SelectInputComponent
        fieldName="createdTime"
        options={CREATED_TIME_OPTIONS}
        onChange={onChange}
        value={value}
        placeholder=" Select Created Time"
        //multiple={true}
        isFilter={true}
        selectOpen={selectOpen}
        handleOpen={handleOpen}
        handleBlur={handleBlur}
      />
      {createdTimeError && <div className="error-text">{createdTimeError}</div>}
      {showCustomDate && (
        <div>
          <CustomDateRangePicker
            onDateRangeChange={handleCustomRangeChange}
            startDateError={createdTimeStartError}
            endDateError={createdTimeEndError}
            setFromDate={setCreatedTimeFromDate}
            setToDate={setCretedTimeToDate}
          />
        </div>
      )}
    </div>
  );
};

export default CreatedTimeFilter;
